export default "__VITE_ASSET__sb9pHdDb__"